<template>
    <div class="catalog-page-top-banner" v-if="obj.src">
        <img :src="obj.src" class="banner-image">
    </div>
</template>
<script>


export default {
    name: 'catalog-page-top-banner',
    selector: '.catalog-page-top-banner',
    props: {
        result: {
            type: Object,
            default: () => catalogData
        }
    },
    data() {
        return {
            obj: this.result
        }
    },
    methods: {


    },
    mounted() {

    }
}
</script>

<style lang="scss" scoped>
    .catalog-page-top-banner{
        width: 100%;
        img{
            display: block;
            width: 100%;
/*            max-height: 400px;
            object-fit: cover;*/
        }
    }
</style>